/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Automation_Action_Move_CaseInputs */

const en_automation_action_move_case = /** @type {(inputs: Automation_Action_Move_CaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move case to ${i?.step}`)
};

const pt_br2_automation_action_move_case = /** @type {(inputs: Automation_Action_Move_CaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover caso para ${i?.step}`)
};

/**
* | output |
* | --- |
* | "Move case to {step}" |
*
* @param {Automation_Action_Move_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_move_case = /** @type {((inputs: Automation_Action_Move_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_Move_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_move_case(inputs)
	return pt_br2_automation_action_move_case(inputs)
});